import React from 'react'

import { useModal } from 'hooks'
import { QUESTION_STATUSES } from '../model'

type QuestionToDelete = {
  item: { status?: string; [key: string]: unknown }
  index: number
}

// NOTE: hook that exposes delete interview template question
// modal state and handlers for other local hooks and interview
// templates creator components
export const useDeleteQuestionModal = handlers => {
  const { handleDeleteQuestion, handleUpgradeQuestion } = handlers

  const [question, setQuestion] = React.useState<QuestionToDelete | null>(null)

  const { handleClose, handleOpen, isOpen } = useModal()

  const handleDeleteQuestionClose = React.useCallback(() => {
    setQuestion(null)
    handleClose()
  }, [handleClose, setQuestion])

  const handleDeleteQuestionConfirm = React.useCallback(() => {
    question?.item?.status === QUESTION_STATUSES.INSERTED
      ? handleDeleteQuestion(question?.index)
      : handleUpgradeQuestion(question?.index, {
          ...question?.item,
          status: QUESTION_STATUSES.DELETED,
        })
    handleClose()
  }, [question, handleClose, handleDeleteQuestion, handleUpgradeQuestion])

  const handleDeleteQuestionOpen = React.useCallback(
    ({ item, index }: QuestionToDelete) => {
      handleOpen()
      setQuestion({ item, index })
    },
    [handleOpen, setQuestion],
  )

  return {
    handleDeleteQuestionClose,
    handleDeleteQuestionConfirm,
    handleDeleteQuestionOpen,
    isDeleteQuestionOpen: isOpen,
  }
}
